import { h, Fragment } from 'preact'

export type UnifiedIntlOptions = {
  signDisplay?: 'exceptZero'
}

type Props = {
  value?: number
  options?: Intl.NumberFormatOptions & UnifiedIntlOptions
}

export function FormattedNumber(props: Props) {
  const { value, options = {} } = props
  const exceptZero = options.signDisplay === 'exceptZero'
  const newOptions = { ...options }
  if (exceptZero) {
    newOptions.signDisplay = undefined
  }

  if (typeof value === 'undefined' || value === null) {
    return null
  }

  let formattedString: string
  try {
    formattedString = new Intl.NumberFormat('nb', options).format(value)
  } catch (e) {
    console.log(e)
    console.log(value)
    formattedString = ''
  }

  // Patch support for Unified Intl.NumberFormat
  // https://github.com/tc39/proposal-unified-intl-numberformat (Stage 3)
  if (exceptZero && value > 0 && !formattedString.startsWith('+')) {
    formattedString = '+' + formattedString
  }
  return <Fragment>{formattedString}</Fragment>
}
